var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAdminUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .136.329c4.131 10.004 13.78 16.618 24.603 16.618h10.074c22.091 0 40 17.908 40 40v20c0 22.091-17.909 40-40 40H24.739c-10.823 0-20.472 6.613-24.603 16.617l-.136.329c-4.155 10.004-2.021 21.51 5.639 29.169l7.122 7.122c15.621 15.621 15.621 40.948 0 56.569l-14.142 14.142c-15.621 15.621-40.948 15.621-56.569 0l-7.122-7.122c-7.659-7.659-19.165-9.794-29.169-5.639l-.329.137c-10.004 4.13-16.618 13.779-16.618 24.602v10.074c0 22.091-17.908 40-39.999 40h-20c-22.092 0-40-17.909-40-40v-10.074c0-10.823-6.614-20.472-16.618-24.602l-.329-.137c-10.004-4.155-21.51-2.02-29.169 5.639l-7.122 7.122c-15.621 15.621-40.948 15.621-56.569 0l-14.142-14.142c-15.621-15.621-15.621-40.948 0-56.569l7.122-7.122c7.66-7.659 9.794-19.165 5.639-29.169l-.136-.329c-4.131-10.004-13.78-16.617-24.603-16.617h-10.073c-22.092 0-40-17.909-40-40v-20c0-22.092 17.908-40 40-40h10.073c10.823 0 20.472-6.614 24.603-16.618l.136-.329",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(417.188 189.053)",
    fill: "none",
    stroke: "#dbd4ce",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c4.367-18.367-9.607-35.99-28.487-35.99h-245.418c-18.879 0-32.854 17.623-28.487 35.99 16.228 68.249 77.982 119.01 151.196 119.01 40.508 0 77.782-15.539 105.396-40.981",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(408.196 55.99)",
    fill: "none",
    stroke: "#dbd4ce",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 44.183 35.817 80 80 80s80-35.817 80-80-35.817-80-80-80S0-44.183 0 0Z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(177 256)",
    fill: "none",
    stroke: "#dbd4ce",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAdminUser);
export default __webpack_public_path__ + "static/media/manage-admin-user.89c9ae44cd5d12dc5bd9c5440be8fd59.svg";
export { ForwardRef as ReactComponent };